/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default ({authGuard, guestGuard}) => [
  ...authGuard([
    {
      path: "",
      component: () => import("../layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          name: 'dashboard',
          component: () => import('@/views/pages/BrokingTools/BrokingTools.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'BrokingTools', active: true }
            ],
            pageTitle: 'BrokingTools',
            metaTitle: 'Home',
          },
        },
        {
          path: '/downloading-all',
          name: 'dashboard.download_all',
          component: () => import('@/views/pages/BrokingTools/DownloadAll.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'BrokingTools' },
              { title: 'Downloading', active: true }
            ],
            pageTitle: 'BrokingTools',
            metaTitle: 'Broking Tools',
          },
        },
        {
          path: "/coverholder-suite",
          name: 'coverholder_suite',
          component: () => import('@/views/pages/CoverholderSuite/CoverholderSuite.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'CoverholderSuite', active: true }
            ],
            pageTitle: 'CoverholderSuite',
            metaTitle: 'Coverholder Suite',
          },
        },
        {
          path: '/coverholder-suite/downloading-all',
          name: 'coverholder_suite.download_all',
          component: () => import('@/views/pages/CoverholderSuite/DownloadAll.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'CoverholderSuite' },
              { title: 'Downloading', active: true }
            ],
            pageTitle: 'CoverholderSuite',
            metaTitle: 'Coverholder Suite',
          },
        },
        {
          path: '/coverholder-suite/upload-referral',
          name: 'upload_referral',
          component: () => import('@/views/pages/Upload/Upload.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'CoverholderSuite' },
              { title: 'UploadReferral', active: true }
            ],
            pageTitle: 'UploadReferral',
            metaTitle: 'Upload Referral',
          },
          props: {
            modelName: 'Referral',
            model: 'submitReferral',
          },
        },
        {
          path: '/notify-a-claim',
          name: 'notify_a_claim',
          component: () => import('@/views/pages/NotifyAClaim/NotifyAClaim.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'NotifyAClaim', active: true }
            ],
            pageTitle: 'NotifyAClaim',
          },
        },
        {
          path: '/notify-a-claim/downloading-all',
          name: 'notify_a_claim.download_all',
          component: () => import('@/views/pages/NotifyAClaim/DownloadAll.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'NotifyAClaim' },
              { title: 'Downloading', active: true }
            ],
            pageTitle: 'NotifyAClaim',
          },
        },
        {
          path: '/upload-referral/success',
          name: 'upload_referral.success',
          component: () => import('@/views/pages/Upload/UploadSuccessful.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'CoverholderSuite' },
              { title: 'UploadReferral' },
              { title: 'Success', active: true }
            ],
            pageTitle: 'UploadReferral',
            metaTitle: 'Upload Referral',
          },
          props: {
            modelName: 'Referral',
          },
        },
        {
          path: '/coverholder-suite/upload-referral/error',
          name: 'upload_referral.error',
          component: () => import('@/views/pages/Upload/UploadNotSuccessful.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'CoverholderSuite' },
              { title: 'UploadReferral' },
              { title: 'Error', active: true }
            ],
            pageTitle: 'UploadReferral',
            metaTitle: 'Upload Referral',
          },
          props: {
            modelName: 'Referral',
          },
        },
        {
          path: '/request-quotation',
          name: 'upload_quotation',
          component: () => import('@/views/pages/Upload/Upload.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'RequestQuotation', active: true }
            ],
            pageTitle: 'RequestQuotation',
            metaTitle: 'Request Quotation',
          },
          props: {
            modelName: 'Quotation',
            model: 'submitQuotation',
          },
        },
        {
          path: '/request-quotation/success',
          name: 'upload_quotation.success',
          component: () => import('@/views/pages/Upload/UploadSuccessful.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'RequestQuotation' },
              { title: 'Success', active: true }
            ],
            pageTitle: 'RequestQuotation',
            metaTitle: 'Request Quotation',
          },
          props: {
            modelName: 'Quotation',
          },
        },
        {
          path: '/request-quotation/error',
          name: 'upload_quotation.error',
          component: () => import('@/views/pages/Upload/UploadNotSuccessful.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'RequestQuotation' },
              { title: 'Error', active: true }
            ],
            pageTitle: 'RequestQuotation',
            metaTitle: 'Request Quotation',
          },
          props: {
            modelName: 'Quotation',
          },
        },
        {
          path: '/work-in-progress/',
          name: 'work_in_progress',
          component: () => import('@/views/pages/WorkInProgress/WorkInProgress.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'WorkInProgress', active: true }
            ],
            pageTitle: 'WorkInProgress',
            metaTitle: 'Work in Progress',
          },
        },
      ],
    },
  ]),
  // Guest routes.
  ...guestGuard([
    {path: "*", redirect: {name: "login"}},
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Callback.vue"),
    },
    {
      path: "/callback",
      name: "auth-callback",
      component: () => import("@/views/Callback.vue"),
    },
  ])
]
